import { render, staticRenderFns } from "./silber.vue?vue&type=template&id=58e2795f&scoped=true"
import script from "./silber.vue?vue&type=script&lang=js"
export * from "./silber.vue?vue&type=script&lang=js"
import style0 from "./silber.vue?vue&type=style&index=0&id=58e2795f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e2795f",
  null
  
)

export default component.exports